export { default } from './RenderOnlyOnClient';
